var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { pushErrorEvent } from '../analytics';
import { RETURN_STATUS } from '../../constants/returns';
import { FULFILLMENT_TYPE, ORDER_STATUS, ORDER_STATUS_MESSAGE, STATUS_CODE, CANCELATION_STATUS, } from '../../constants/status';
import { orderReturnFGByDate } from '../order-details/OrderDetailsUtils';
/**
 * Separates the returned items from the fulfillment groups, and returns the new array with the returned items at the end
 */
export var separateReturnedFG = function (fulfillmentGroups) {
    var _a, _b;
    // These two variables will hold the new fulfillment groups for returned items depending on their status
    var completeReturnsFG = [];
    var initializedReturnsFG = [];
    var inProgressReturnsFG = [];
    // add items from returnShipment to their respective arrays, will also modify the original fulfillment groups to being in Delivered states
    var modifiedOriginalGroups = fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.map(function (fulfillmentGroup) {
        var modifiedFG = createReturnedItemsFulfillmentGroups(fulfillmentGroup, completeReturnsFG, initializedReturnsFG, inProgressReturnsFG);
        return modifiedFG;
    });
    // filter fg that have all qty 0 for line items
    var filteredGroups = filterEmptyFulfillmentGroups(modifiedOriginalGroups);
    // order the returned fg by their desc date
    orderReturnFGByDate(initializedReturnsFG);
    orderReturnFGByDate(inProgressReturnsFG);
    orderReturnFGByDate(completeReturnsFG);
    // add the returned fg to the filtered groups
    var orderedGroups = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (filteredGroups !== null && filteredGroups !== void 0 ? filteredGroups : []), true), initializedReturnsFG, true), inProgressReturnsFG, true), completeReturnsFG, true);
    function moveOutOfStockToFront(groups) {
        var outOfStockGroups = groups.filter(function (fg) { return fg.cancelationStatus === CANCELATION_STATUS.OUT_OF_STOCK; });
        var otherGroups = groups.filter(function (fg) { return fg.cancelationStatus !== CANCELATION_STATUS.OUT_OF_STOCK; });
        return __spreadArray(__spreadArray([], outOfStockGroups, true), otherGroups, true);
    }
    return {
        orderedGroups: moveOutOfStockToFront(orderedGroups),
        filteredGroups: filteredGroups,
        initializedReturnsFG: initializedReturnsFG,
        inProgressReturnsFG: inProgressReturnsFG,
        completeReturnsFG: completeReturnsFG,
        firstInitializedReturnIndex: filteredGroups === null || filteredGroups === void 0 ? void 0 : filteredGroups.length,
        firstInProgressReturnIndex: ((_a = filteredGroups === null || filteredGroups === void 0 ? void 0 : filteredGroups.length) !== null && _a !== void 0 ? _a : 0) + initializedReturnsFG.length,
        firstCompleteReturnIndex: ((_b = filteredGroups === null || filteredGroups === void 0 ? void 0 : filteredGroups.length) !== null && _b !== void 0 ? _b : 0) +
            initializedReturnsFG.length +
            inProgressReturnsFG.length,
    };
};
/**
 * For each enty in returnShipment, it will find the corresponding lineItem in the fg, modify the info, and add it to the returnArray
 */
export var createReturnedItemsFulfillmentGroups = function (fulfillmentGroup, completeReturns, initializedReturns, inProgressReturns) {
    var _a;
    var modifiedFG = __assign({}, fulfillmentGroup);
    (_a = fulfillmentGroup.returnShipments) === null || _a === void 0 ? void 0 : _a.forEach(function (returnOrder) {
        var _a;
        (_a = returnOrder.linkedLineIds) === null || _a === void 0 ? void 0 : _a.forEach(function (itemReturned) {
            var _a, _b, _c, _d, _e, _f;
            var fgItemIndex = (_a = fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.findIndex(function (item) { return itemReturned.lineId === item.lineId; });
            if (fgItemIndex === undefined || fgItemIndex === -1)
                return;
            var itemInfo = (_b = fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b[fgItemIndex];
            if (!itemInfo)
                return;
            // modify original items to add field in case they need to be hidden, and to change the description and status code
            if (modifiedFG.lineItems && modifiedFG.lineItems[fgItemIndex]) {
                modifiedFG.lineItems[fgItemIndex].hideEmptyItem = true;
                if (modifiedFG.fulfillmentType === FULFILLMENT_TYPE.STH) {
                    modifiedFG.lineItems[fgItemIndex].statusDescription =
                        (_c = ORDER_STATUS.STH) === null || _c === void 0 ? void 0 : _c[105];
                    modifiedFG.lineItems[fgItemIndex].statusCode = STATUS_CODE.DELIVERED;
                }
                else if (modifiedFG.fulfillmentType === FULFILLMENT_TYPE.BOSS) {
                    modifiedFG.lineItems[fgItemIndex].statusDescription =
                        (_d = ORDER_STATUS.BOSS) === null || _d === void 0 ? void 0 : _d[200];
                    modifiedFG.lineItems[fgItemIndex].statusCode = STATUS_CODE.COMPLETED;
                }
                else if (modifiedFG.fulfillmentType === FULFILLMENT_TYPE.BODFS) {
                    modifiedFG.lineItems[fgItemIndex].statusDescription =
                        (_e = ORDER_STATUS.BODFS) === null || _e === void 0 ? void 0 : _e[105];
                    modifiedFG.lineItems[fgItemIndex].statusCode = STATUS_CODE.DELIVERED;
                }
            }
            // Skip creating the new FG for combo items (after they have been set as hideEmptyItem=true and will be hidden)
            if (((_f = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.parentLine) === null || _f === void 0 ? void 0 : _f.relationType) === 'COMBO')
                return;
            var newInfo = __assign({}, itemInfo);
            newInfo.returnOrderTrackingInfo = returnOrder.returnOrderTrackingInfo;
            newInfo.statusUpdatedDate = returnOrder.returnStatusUpdatedDate;
            newInfo.actions = __assign(__assign({}, newInfo.actions), { returnOnlineAllowed: false });
            if (returnOrder.returnStatus === RETURN_STATUS.COMPLETED) {
                newInfo.statusDescription = ORDER_STATUS_MESSAGE.Returned[150];
                newInfo.statusCode = STATUS_CODE.RETURNED;
                newInfo.returnedQuantity = itemReturned.quantity;
                addToReturnArray(returnOrder, completeReturns, fulfillmentGroup, newInfo);
            }
            else if (returnOrder.returnStatus === RETURN_STATUS.INITIATED) {
                newInfo.statusDescription = ORDER_STATUS_MESSAGE.Returned[101];
                newInfo.statusCode = STATUS_CODE.RETURN_IN_PROGRESS;
                newInfo.currentQuantity = itemReturned.quantity;
                newInfo.returnByDate = returnOrder.returnByDate;
                addToReturnArray(returnOrder, initializedReturns, fulfillmentGroup, newInfo);
            }
            else if (returnOrder.returnStatus === RETURN_STATUS.IN_PROGRESS) {
                newInfo.statusDescription = ORDER_STATUS_MESSAGE.Returned[151];
                newInfo.statusCode = STATUS_CODE.RETURN_IN_PROGRESS;
                newInfo.currentQuantity = itemReturned.quantity;
                newInfo.returnByDate = returnOrder.returnByDate;
                addToReturnArray(returnOrder, inProgressReturns, fulfillmentGroup, newInfo);
            }
            else {
                pushErrorEvent('order details', '', 'invalid return status', 'page');
            }
        });
    });
    return modifiedFG;
};
/**
 * Will add the itemInfo to the returnArray, if the returnOrder with the date is not already in the array, it will add a new fg copied from the original fg
 */
export var addToReturnArray = function (returnOrder, returnArray, currentGroup, itemInfo) {
    var _a;
    var returnIndex = returnArray.findIndex(function (item) { return item.returnDate === returnOrder.returnStatusUpdatedDate; });
    // not found, create new fg
    if (returnIndex === -1) {
        returnArray.push(__assign(__assign({}, currentGroup), { 
            // remove shipping, causes weird duplicates, not be needed after returning i think
            shippingAndHandling: undefined, fulfillmentDate: returnOrder.returnStatusUpdatedDate, returnShipments: [], returnDate: returnOrder.returnStatusUpdatedDate, returnByDate: returnOrder.returnByDate, isSoris: returnOrder.isSoris, returnOrderNumber: returnOrder.returnOrderNumber, lineItems: [itemInfo] }));
    }
    else {
        (_a = returnArray[returnIndex].lineItems) === null || _a === void 0 ? void 0 : _a.push(itemInfo);
    }
};
/**
 * Util function that will filter out the fulfillmentgroups that have all line items with 0 qty
 */
export var filterEmptyFulfillmentGroups = function (fulfillmentGroups) {
    // remove the line items that have 0 qty and have the hideEmptyItem flag
    var modifiedFG = fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.map(function (group) {
        var _a;
        var filteredLineItems = (_a = group.lineItems) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
            return !(item.currentQuantity === undefined || item.currentQuantity === 0) ||
                !item.hideEmptyItem;
        });
        return __assign(__assign({}, group), { lineItems: filteredLineItems });
    });
    // delete all empty fg (no line items)
    var filteredFulfillmentGroups = modifiedFG === null || modifiedFG === void 0 ? void 0 : modifiedFG.filter(function (group) {
        return group.lineItems && group.lineItems.length > 0;
    });
    return filteredFulfillmentGroups;
};
